<template>
  <div class="auth__head d-flex flex-column justify-content-center">
    <CIcon
      class="c-sidebar-brand-full"
      name="logo"
      size="custom-size"
      :height="32"
      viewBox="0 0 136 34"
    />
    <PAlert color="primary" class="my-5"
            extra-class="py-2">
      <div class="d-flex align-items-center justify-content-space-between">
        <div>
          <CIcon name="cipInfo" :width="16" class="mr-2"/>
        </div>
        <span v-translate translate-context="register.info'" class="text-left font-weight-medium">Reserved area for photographers</span>
      </div>

    </PAlert>
    <h1 class="font-weight-semi-bold">{{ title }}</h1>
  </div>
</template>
<script>
import PAlert from "@/components/PAlert.vue";

export default {
  name: "OnBoardingHeader",
  components: {PAlert},
  props: {
    title: {
      type: String,
      required: false
    }
  }
}
</script>


<style scoped>

</style>